import {
  ActionType,
  FullStressTypePDFDownloadResponse,
  IFullStressTypeDownloadPdfData,
} from "models/stressCheck/fullStressTypeDownloadPdf";

export const fullStressPdfDownloadAction = (
  payload: IFullStressTypeDownloadPdfData
) => {
  return {
    type: ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF_ERROR,
    payload,
  };
};

export const handleSuccesAction = (
  payload: FullStressTypePDFDownloadResponse
) => {
  return {
    type: ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.FULL_STRESS_TYPE_DOWNLOAD_PDF_RESET_DATA,
  };
};
